import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { hasStoredSession } from "@/auth/tokenRefresh";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const [isAuthed, setIsAuthed] = useState(hasStoredSession);

  useEffect(() => {
    const handleAuthChanged = () => {
      setIsAuthed(hasStoredSession());
    };

    window.addEventListener("auth:changed", handleAuthChanged);
    window.addEventListener("storage", handleAuthChanged);

    return () => {
      window.removeEventListener("auth:changed", handleAuthChanged);
      window.removeEventListener("storage", handleAuthChanged);
    };
  }, []);

  if (!isAuthed) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}

export default RequireAuth;